<script lang="ts">
	import Autocomplete from '@smui-extra/autocomplete';
	import Card from '@smui/card';
	import Checkbox from '@smui/checkbox';
	import FormField from '@smui/form-field';
	import Select, { Option } from '@smui/select';
	import Input from '@smui/textfield';
	import Svelecte from 'svelecte';
	import CopyToClipboard from 'svelte-copy-to-clipboard';
	import { _ } from 'svelte-i18n';
	import { push } from 'svelte-spa-router';
	import { derived } from 'svelte/store';
	import FieldLoading from '../../../..//shared/components/common/Loading/FieldLoading.svelte';
	import HorizontalFieldsLoading from '../../../..//shared/components/common/Loading/HorizontalFieldsLoading.svelte';
	import SurveyLoading from '../../../..//shared/components/common/Loading/SurveyLoading.svelte';
	import LocaleSelector from '../../../..//shared/components/common/LocaleSelector.svelte';
	import Title from '../../../..//shared/components/common/Title.svelte';
	import ConfirmModal from '../../../../shared/components/common/Modal/ConfirmModal.svelte';
	import Survey from '../../../../shared/components/common/Survey/Survey.svelte';
	import SurveyBuilder from '../../../../shared/components/common/Survey/SurveyBuilder/SurveyBuilder.svelte';
	import Area from '../../../../shared/models/Area/Area';
	import AziendaEnte from '../../../../shared/models/AziendaEnte/AziendaEnte';
	import TipoAziendaEnte from '../../../../shared/models/AziendaEnte/TipoAziendaEnte';
	import Questionario from '../../../../shared/models/Questionario/Questionario';
	import QuestionarioTipoAziendaEnte from '../../../../shared/models/Questionario/QuestionarioTipoAziendaEnte';
	import QuestionarioTipoRispondente from '../../../../shared/models/Questionario/QuestionarioTipoRispondente';
	import SetQuestionario from '../../../../shared/models/Questionario/SetQuestionario';
	import TipoRispondente from '../../../../shared/models/Questionario/TipoRispondente';
	import { locale, setupI18n } from '../../../../shared/services/i18n';
	import { hasRoleAreaManager, hasRoleCompanyManager, hasRoleSysAdmin, hasRoleSysAdminOrAreaManager, hasRoleSysAdminOrCompanyManager } from './../../../../shared/stores';

	export let params = {
		id: '0',
	};

	let [data, loading, error] = Questionario.get(params.id);
	let [dataQuestionari, loadingQuestionari, errorQuestionari] = Questionario.getList({ master: true });
	let [dataAree, loadingAree, errorAree] = Area.getList();
	let [dataAziendeEnti, loadingAziendeEnti, errorAziendeEnti] = AziendaEnte.getList();
	let [dataTipiAziendaEnte, loadingTipiAziendaEnte, errorTipiAziendaEnte] = TipoAziendaEnte.getList();
	let [dataTipiRispondenti, loadingTipiRispondenti, errorTipiRispondenti] = [null, null, null];
	let [dataSetQuestionari, loadingSetQuestionari, errorSetQuestionari] = SetQuestionario.getList();

	let openConfirmEditDialog: boolean = false;
	let openConfirmApproveByAdminDialog: boolean = false;

	let selectedArea: Area = new Area();
	$: selectedArea = $data.area;

	let selectedAziendaEnte: AziendaEnte = new AziendaEnte();
	$: selectedAziendaEnte = $data.aziendaEnte;

	let selectedTipiAziendaEnte: number[] = [];
	let selectedTipiRispondente: number[] = [];

	const dataAndDataTipiAziendaEnte = derived(
		[loading, loadingTipiAziendaEnte], 
		([$loading, $loadingTipiAziendaEnte]) => {
			if (!$loading && !$loadingTipiAziendaEnte) {
				if ($data.scuola) {
					if ($data.questionarioTipiAziendaEnte.length > 0) {
						selectedTipiAziendaEnte = $data.questionarioTipiAziendaEnte.map((item) => {
							return item.tipoAziendaEnteId;
						});

						const selectedTipiAziendaEnteObjects = $dataTipiAziendaEnte?.response?.filter(oggetto => 
							selectedTipiAziendaEnte.includes(oggetto.id)
						);

						[dataTipiRispondenti, loadingTipiRispondenti, errorTipiRispondenti] = TipoRispondente.getList({ tipiAziendaEnte: selectedTipiAziendaEnteObjects.map((item) => { return item.descrizione; }) });
						return $data;
					}
				}
			}
		}
	);

	dataAndDataTipiAziendaEnte.subscribe(value => {
		if (value) {
			if (value?.questionarioTipiRispondente?.length > 0) {
				selectedTipiRispondente = value.questionarioTipiRispondente.map((item) => {
					return item.tipoRispondenteId;
				});
			}
		}
	});

	function isTipoRispondenteValid() {
		return selectedTipiRispondente.every(id => 
			$dataTipiRispondenti.response.some(obj => obj.id === id)
		);
	}

	$: if (selectedTipiRispondente?.length > 0 && $dataTipiRispondenti?.response?.length > 0 && !isTipoRispondenteValid()) {
		selectedTipiRispondente = [];
	}

	
	$: if ($data.scuola === false) {
			$data.questionarioTipiAziendaEnte = [];
			selectedTipiAziendaEnte = [];
			$data.questionarioTipiRispondente = [];
			selectedTipiRispondente = [];
		}

	let previousLayout = null;

	let layout = undefined;

	$: if (layout && layout.questionarioJson) {
		previousLayout = layout;
	}

	let loadingQuestionario = false;
	let editableQuestionario = false;

	$: if ($data.stato !== 'Approvato' && $hasRoleAreaManager) {
			loadingQuestionario = true;
			editableQuestionario = true;
			loadingQuestionario = false;
		} else if (!$data?.url && $hasRoleCompanyManager) {
			loadingQuestionario = true;
			editableQuestionario = true;
			loadingQuestionario = false;
		} else {
			loadingQuestionario = true;
			editableQuestionario = false;
			loadingQuestionario = false;
		}

	$: if ($data.dataInizioValidita && $data.dataFineValidita) {
		if (new Date($data.dataInizioValidita) > new Date($data.dataFineValidita)) {
			$data.dataInizioValidita = $data.dataFineValidita;
		}
	}

	let surveyKey = 0;

	function submit() {
		if ($data.setQuestionario) {
			if ($data.setQuestionario?.$created && $data.setQuestionario?.nome) {
				$data.setQuestionarioId = null;
				$data.setQuestionario = new SetQuestionario( { id: 0,  nome: $data.setQuestionario.nome } );
			} else {
				if ($data.setQuestionario?.id) {
					$data.setQuestionarioId = $data.setQuestionario.id;
				}
			}
		} else {
			$data.setQuestionarioId = null;
		}
		$data.questionarioTipiAziendaEnte = [];
		for (const tipoAziendaEnteId of selectedTipiAziendaEnte) {
			const questionarioTipoAziendaEnte = new QuestionarioTipoAziendaEnte();
			questionarioTipoAziendaEnte.tipoAziendaEnteId = tipoAziendaEnteId;
			questionarioTipoAziendaEnte.questionarioId = $data.id;

			$data.questionarioTipiAziendaEnte.push(questionarioTipoAziendaEnte);
		}
		$data.questionarioTipiRispondente = [];
		for (const tipoRispondenteId of selectedTipiRispondente) {
			const questionarioTipoRispondente = new QuestionarioTipoRispondente();
			questionarioTipoRispondente.tipoRispondenteId = tipoRispondenteId;
			questionarioTipoRispondente.questionarioId = $data.id;
			$data.questionarioTipiRispondente.push(questionarioTipoRispondente);
		}
		[data, loading, error] = Questionario.save($data);
	}

	function approveByAdmin() {
		if ($data.setQuestionario) {
			if ($data.setQuestionario?.$created && $data.setQuestionario?.nome) {
				$data.setQuestionarioId = null;
				$data.setQuestionario = new SetQuestionario( { id: 0,  nome: $data.setQuestionario.nome } );
			} else {
				if ($data.setQuestionario?.id) {
					$data.setQuestionarioId = $data.setQuestionario.id;
				}
			}
		} else {
			$data.setQuestionarioId = null;
		}
		[data, loading, error] = Questionario.approveByAdmin($data);
	}

	function approveByAreaManager() {
		[data, loading, error] = Questionario.approveByAreaManager($data);
	}

	function publish() {
		[data, loading, error] = Questionario.publishToAziendaEnte($data);
	}

	function navigateToMultipleCompilation() {
        push(`/questionariosysadmin/${$data.questionarioGuid}`);
    }

	function generateUrl() {
		[data, loading, error] = Questionario.generateURL($data, () => {
			setTimeout(() => {
				window.location.reload();
			}, 3000);
		});
	}

</script>

{#if $hasRoleSysAdmin && $data.id > 0}
    {#if $data.isMaster || $data.stato === 'Approvato'}
        <div class="flex mt-4 space-x-4">
            <a href="#/questionariovalori/{$data.id}/SmartWorking" class="btn-blue px-4 py-2 rounded">
                <span class="material-icons-outlined mr-2">settings</span>
                Configura valori Smart Working
            </a>
            <a href="#/questionariovalori/{$data.id}/PSCL" class="btn-blue px-4 py-2 rounded">
                <span class="material-icons-outlined mr-2">settings</span>
                Configura valori PSCL
            </a>
        </div>
    {:else}
        <div class="p-3 mt-4 text-yellow-700 bg-yellow-100 border-l-4 border-yellow-500">
            <p class="font-bold">Configurazione valori non disponibile</p>
            <p>Per configurare i valori Smart Working e PSCL è necessario prima approvare il questionario per tutte le aree 
            (usando il pulsante <span class="inline-flex items-center"><span class="material-icons-outlined text-sm">assignment_turned_in</span> in alto)</p>
        </div>
    {/if}
{/if}

<ConfirmModal
    content="Questa operazione rimuoverà le risposte non più valide in base alle opzioni aggiornate del questionario. Vuoi procedere con la conferma?"
	bind:showModal="{openConfirmEditDialog}"
	onConfirm="{() => submit()}"
/>
<ConfirmModal
	content="Sei sicuro di voler approvare il questionario? {$data?.setQuestionario?.nome ? 'Verrà associato al set questionari ' + $data?.setQuestionario?.nome : 'Nessun set questionari selezionato'}"
	bind:showModal="{openConfirmApproveByAdminDialog}"
	onConfirm="{() => approveByAdmin()}"
/>
<Card class="md:px-8 md:py-8" padded>
	<div class="flex justify-between">
		<Title title="{$_('page.survey.detail.title')}" />
		<div class="sm:flex-nowrap sm:space-x-4 flex flex-wrap">
			{#if (($data?.stato !== 'Approvato') || ($data.stato === "Approvato" && !$data?.url)) && $hasRoleSysAdminOrAreaManager}
				<button type="submit" form="form" class="btn-white h-14 w-14 sm:h-16 sm:w-16">
					<span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">save</span>
				</button>
			{/if}
			{#if $data?.id && $data?.stato !== 'Approvato' && (!$data?.areaId || $data?.areaId == 0) && $hasRoleSysAdmin}
				<button
					title="{$data?.scuola ? $_('page.survey.detail.approve_to_school_areas') : $_('page.survey.detail.approve_to_areas')}"
					type="button"
					class="btn-white h-14 w-14 sm:h-16 sm:w-16"
					on:click={() => (openConfirmApproveByAdminDialog = true)}
				>
					<span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">assignment_turned_in</span>
				</button>
			{/if}
			{#if $data?.id && $data?.stato !== 'Approvato' && $data?.areaId > 0 && (!$data?.aziendaEnteId || $data?.aziendaEnteId == 0) && $hasRoleSysAdmin}
				<button
					title="{$data.scuola ? $_('page.survey.detail.approve_to_school_companies/entities_of_area') : $_('page.survey.detail.approve_to_companies/entities_of_area')} {selectedArea?.nomeComune}"
					type="button"
					class="btn-white h-14 w-14 sm:h-16 sm:w-16"
					on:click={approveByAreaManager}
				>
					<span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">assignment_turned_in</span>
				</button>
			{/if}
			{#if !$data?.url && $hasRoleCompanyManager}
				<button
					title="{$_('page.survey.detail.generate_url')}"
					type="button"
					class="btn-white h-14 w-14 sm:h-16 sm:w-16"
					on:click={generateUrl}
				>
					<span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">http</span>
				</button>
			{/if}
			{#if $data?.isVisibleToAziendaEnte == false && $data?.aziendaEnteId > 0 && $hasRoleSysAdminOrAreaManager}
				<button
					title="{$_('page.survey.detail.publish_to_company/entity')} {selectedAziendaEnte?.nomeAziendaEnte}"
					type="button"
					class="btn-white h-14 w-14 sm:h-16 sm:w-16"
					on:click={publish}
				>
					<span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">done</span>
				</button>
			{/if}
			{#if $data?.url && $hasRoleSysAdminOrCompanyManager}
				<button title="Modifica" type="button" class="btn-white h-14 w-14 sm:h-16 sm:w-16" on:click="{() => (openConfirmEditDialog = true)}">
					<span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">edit</span>
				</button>
			{/if}
			{#if $hasRoleSysAdmin && $data?.url}
                <button
                    title="{$_('page.survey.detail.multiple_compilation')}"
                    type="button"
                    class="btn-white h-14 w-14 sm:h-16 sm:w-16"
                    on:click={navigateToMultipleCompilation}
                >
                    <span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">group_add</span>
                </button>
            {/if}
		</div>
	</div>
	{#if $loading}
		<HorizontalFieldsLoading />
		<div class="md:col-start-1 md:col-end-5 pt-4">
			<SurveyLoading />
		</div>
	{:else}
		<form on:submit|preventDefault="{submit}" id="form">
			<div class="gap-x-8 grid grid-cols-2 px-4 pt-4">
				{#if $hasRoleSysAdmin && $data?.areaId}
					{#if $loadingAree}
						<FieldLoading />
					{:else}
						<Select
							disabled
							key="{(area) => `${(area && area.id) || ''}`}"
							label="{$_('page.survey.detail.area')}"
							bind:value="{selectedArea}"
						>
							{#if $dataAree.response}
								<Option value="{{}}" />
								{#each $dataAree.response as area (area.id)}
									{#if area.nomeComune}
										<Option value="{area}">{area.nomeComune}</Option>
									{/if}
								{/each}
							{/if}
						</Select>
					{/if}
				{/if}
				{#if !$hasRoleCompanyManager && $data?.aziendaEnteId}
					{#if $loadingAziendeEnti}
						<FieldLoading />
					{:else}
						<Select
							disabled
							key="{(aziendaEnte) => `${(aziendaEnte && aziendaEnte.id) || ''}`}"
							label="{$_('page.survey.detail.company/entity')}"
							bind:value="{selectedAziendaEnte}"
						>
							{#if $dataAziendeEnti && $dataAziendeEnti.response}
								<Option value="{{}}" />
								{#each $dataAziendeEnti.response as aziendaEnte (aziendaEnte.id)}
									{#if aziendaEnte?.nomeAziendaEnte}
										<Option value="{aziendaEnte}">{aziendaEnte.nomeAziendaEnte}</Option>
									{/if}
								{/each}
							{/if}
						</Select>
					{/if}
				{/if}
			</div>
			<div class="md:grid-cols-1 lg:grid-cols-3 md:gap-x-8 md:px-4 grid grid-cols-1 pt-4">
				<!--
				<Input disabled="{!$hasRoleSysAdmin}" label="{$_('page.survey.detail.code')}" bind:value="{$data.codice}" />
				-->
				<Input required disabled="{!$hasRoleSysAdmin}" label="{$_('page.survey.detail.description')}" bind:value="{$data.descrizione}" />
				<Input
					required
					disabled="{!$hasRoleSysAdmin}"
					label="{$_('page.survey.detail.start_validity')}"
					bind:value="{$data.dataInizioValidita}"
					type="datetime-local"
					on:click={(e) => {
						if (!e.target.disabled) {
							try {
								e.target.showPicker();
							} catch (error) {
								// Fallback per browser che non supportano showPicker
							}
						}
					}}
				/>
				<Input
					required
					disabled="{!$hasRoleSysAdminOrCompanyManager}"
					label="{$_('page.survey.detail.end_validity')}"
					bind:value="{$data.dataFineValidita}"
					type="datetime-local"
					on:click={(e) => {
						if (!e.target.disabled) {
							try {
								e.target.showPicker();
							} catch (error) {
								// Fallback per browser che non supportano showPicker
							}
						}
					}}
				/>
			</div>
			<div class="md:grid-cols-4 md:gap-x-8 md:px-4 grid grid-cols-1 pt-4">
				{#if !($data.stato === "Approvato" && !$data.scuola)}
					<div class="flex items-center justify-center h-full">
						<FormField>
							<Checkbox disabled={!$hasRoleSysAdmin || $data.areaId || $data.stato === "Approvato"} bind:checked="{$data.scuola}" />
							<span slot="label">Scuola</span>
						</FormField>
					</div>
				{/if}
				{#if $data.scuola}
					{#if $loadingTipiAziendaEnte}
						<FieldLoading />
					{:else}
						<Svelecte
							disabled={!$hasRoleSysAdmin || $data.areaId || $data.stato === "Approvato"}
							required={$data.scuola}
							options="{$dataTipiAziendaEnte.response}"
							labelField="{'descrizione'}"
							valueField="{'id'}"
							bind:value="{selectedTipiAziendaEnte}"
							multiple
							placeholder="Seleziona tipi scuola"
							on:change="{(e) => {
								[dataTipiRispondenti, loadingTipiRispondenti, errorTipiRispondenti] = TipoRispondente.getList({ tipiAziendaEnte: e.detail.map(item => item.descrizione) });
							}}"
							class="svelecte-control	pt-1.5"
						/>
					{/if}
					{#if selectedTipiAziendaEnte?.length > 0}
						{#if $loadingTipiRispondenti}
							<FieldLoading />
						{:else}
						<Svelecte
							disabled={!$hasRoleSysAdmin || $data.areaId || $data.stato === "Approvato"}
							required={$data.scuola}
							options="{$dataTipiRispondenti?.response}"
							labelField="{'descrizione'}"
							valueField="{'id'}"
							bind:value="{selectedTipiRispondente}"
							multiple
							max={1}
							placeholder="Seleziona rispondente"
							class="svelecte-control	pt-1.5"
						/>
						{/if}
					{/if}
				{/if}
			</div>
			{#if $data?.url && $hasRoleSysAdminOrCompanyManager}
				<div class="md:grid-cols-4 grid grid-cols-1 pt-4">
					<div class="md:col-start-2 md:col-end-4 flex">
						<Input disabled $inpu$id="urlQuestionario" label="URL" bind:value="{$data.url}" class="w-full" />
						<CopyToClipboard text="{$data.url}" let:copy>
							<button
								title="{$_('page.survey.detail.copy_url')}"
								type="button"
								class="hover:bg-transparent w-8 mt-auto text-black bg-transparent"
								on:click|preventDefault="{copy}"
							>
								<span class="material-icons">content_paste</span>
							</button>
						</CopyToClipboard>
					</div>
				</div>
			{/if}
			<div class="md:grid-cols-4 grid grid-cols-1 pt-4">
				{#if $data?.id && $hasRoleSysAdmin}
					{#if !($data?.stato === 'Approvato' && $data?.setQuestionarioId == null)}
						<div class="md:col-start-2 md:col-end-4 flex">
							{#if $loadingQuestionari}
								<FieldLoading customClass="md:col-start-2 w-full" />
							{:else}
								{#if $loadingSetQuestionari}
									<FieldLoading />
								{:else}
									<Svelecte
										disabled={!$hasRoleSysAdmin || $data.areaId || $data?.stato === 'Approvato'}
										options="{$dataSetQuestionari?.response}"
										labelField="{'nome'}"
										valueField="{'id'}"
										bind:value="{$data.setQuestionario}"
										valueAsObject
										strictMode={false}
										creatable
										creatablePrefix=""
										placeholder="Seleziona set questionari"
										class="svelecte-control	pt-1.5"
									/>
								{/if}
							{/if}
						</div>
					{/if}
				{/if}
			</div>
			<div class="flex items-center justify-center p-3">
				<FormField>
					<Checkbox 
						disabled={!$hasRoleSysAdminOrCompanyManager}
						bind:checked="{$data.includiDatiFacoltativi}" />
					<span slot="label">Includi pagina di raccolta dati facoltativi</span>
				</FormField>
			</div>
			<div class="flex items-center justify-center">
				{#if $data?.stato !== 'Approvato' && $hasRoleSysAdmin}
						{#if $loadingQuestionari}
							<FieldLoading customClass="w-72" />
						{:else}
							<Autocomplete
								label="{$_('page.survey.detail.layout')}"
								options="{$dataQuestionari.response}"
								getOptionLabel="{(option) => (option ? `${option.descrizione}` : '')}"
								bind:value="{layout}"
								class="min-w-72"
								textfield$class="w-72"
								on:focusout="{() => {
									if (layout && layout.questionarioJson) {
										$data.questionarioJson = layout.questionarioJson;
										surveyKey++;
									} else if (previousLayout) {
										$data.questionarioJson = '';
										surveyKey++;
									}
								}}"								  
							>
							</Autocomplete>
						{/if}
				{/if}
			</div>
			<div class="text-end py-4">
				<LocaleSelector value="{$locale}" on:locale-changed="{(e) => setupI18n({ withLocale: e.detail })}" />
			</div>
			{#key surveyKey}
				{#if loadingQuestionario || $loading}
					<SurveyLoading />
				{:else}
					{#if $data?.stato !== 'Approvato'}
						<div class="font-bold text-center text-red-600">
							ATTENZIONE: Salvare il questionario prima di uscire cliccando prima sul tasto "Salva" verde presente sulla destra e successivamente sul tasto "Matita" presente in alto a destra
						</div>
						{#if $hasRoleSysAdminOrAreaManager}
							<SurveyBuilder bind:stringifiedJson="{$data.questionarioJson}" />
						{:else}
							<SurveyBuilder bind:stringifiedJson="{$data.questionarioJson}" isRestrictedEditMode={true} />
						{/if}
					{:else}
						{#if $hasRoleSysAdmin}
							<div class="font-bold text-center text-red-600">
								ATTENZIONE: Salvare il questionario prima di uscire cliccando prima sul tasto "Salva" verde presente sulla destra e successivamente sul tasto "Matita" presente in alto a destra
							</div>
							<SurveyBuilder bind:stringifiedJson="{$data.questionarioJson}"/>
						{:else if $hasRoleCompanyManager}
							<div class="font-bold text-center text-red-600">
								ATTENZIONE: Salvare il questionario prima di uscire cliccando prima sul tasto "Salva" verde presente sulla destra e successivamente sul tasto "Matita" presente in alto a destra
							</div>
							<SurveyBuilder bind:stringifiedJson="{$data.questionarioJson}" isRestrictedEditMode={true} />
						{:else}
							<Survey bind:stringifiedJson="{$data.questionarioJson}" />
						{/if}
					{/if}
				{/if}
			{/key}
		</form>
	{/if}
</Card>